/* Utilidades compartidas: identificadores, formato de fecha e imagen. */

// Identificador corto y único para cada captura.
export const uid = () =>
  Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

// Normaliza una URL escrita por el usuario: recorta y antepone https:// si falta.
// Compartida por App (cargar sitio) y Navegador (marcadores) para no duplicarla.
export function normalizarUrl(u) {
  u = (u || "").trim();
  if (!u) return "";
  if (!/^https?:\/\//i.test(u)) u = "https://" + u;
  return u;
}

// Fecha legible en español; tolera valores no parseables.
export function fechaCorta(iso) {
  try {
    return new Date(iso).toLocaleString("es", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch (e) {
    return iso;
  }
}

// Reduce una imagen (dataURL) a un ancho máximo y la recomprime a JPEG.
// Mantiene el peso bajo control para el almacenamiento y el informe.
export function reducirImagen(dataUrl, maxW = 1400) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const esc = Math.min(1, maxW / img.width);
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * esc);
      c.height = Math.round(img.height * esc);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      resolve(c.toDataURL("image/jpeg", 0.82));
    };
    img.src = dataUrl;
  });
}
